import Request from './request';

async function fetch(data) {
    return Request('get', "api/food-relations/get-shop-list", data);
}

export default {
    fetch,
};